module.exports = __webpack_public_path__ + "img/target-13e1e29a-083d-4fc8-a3bf-462bb2910ae3.fbd91f75.png";